export enum ErrorType {
	NOT_ERROR = 0,
	WRONG_CREDENTIALS,
	WRONG_PASSWORD,
	BLOCKED,
	SERVER,
	NOT_ACTIVE_ACCOUNT,
}

export const isAuthenticated = (): boolean => {
	const token = localStorage.getItem('Authorization');
	try {
		return !!token;
	} catch {
		return false;
	}
};
